/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = __webpack_require__(1);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var canvas = document.querySelector('canvas');
var ctx = canvas.getContext('2d');
canvas.width = window.innerWidth;
canvas.height = window.innerHeight;

var lines = 12;
var bits = [];

var drawMeasures = function drawMeasures() {
  var gridSpace = window.innerHeight / lines;

  for (var i = 0; i < lines; i++) {
    ctx.save();

    ctx.beginPath();
    ctx.moveTo(0, gridSpace * i);
    ctx.lineTo(window.innerWidth, gridSpace * i);
    ctx.strokeStyle = 'rgba(80, 227, 194, ' + (i % 2 ? 0.025 : 0.05) + ')';
    ctx.stroke();

    ctx.restore();
  }
};

var Bit = function () {
  function Bit(context) {
    var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var j = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var width = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var length = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 10;
    var vel = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 10;

    _classCallCheck(this, Bit);

    this.ctx = context;
    this.x = x;
    this.j = j;
    this.width = width;
    this.length = length;
    this.vel = vel;
    this.rapid = false;
  }

  _createClass(Bit, [{
    key: 'update',
    value: function update(delta) {
      this.x += (this.rapid ? this.vel * 32 : this.vel) * delta;
      this.x = this.x > window.innerWidth ? 0 - this.length : this.x;
      this.y = window.innerHeight / lines * this.j;

      if (Math.random() < 0.001) {
        this.rapid = !this.rapid;
      }

      if (Math.random() < 0.05) {
        this.rapid = false;
      }
    }
  }, {
    key: 'draw',
    value: function draw() {
      this.ctx.save();

      this.ctx.beginPath();
      this.ctx.moveTo(this.x, this.y);
      this.ctx.lineTo(this.x + this.length, this.y);
      this.ctx.strokeStyle = this.rapid ? '#FFE474' : 'rgba(80, 227, 194, 1)';
      this.ctx.lineWidth = this.width;
      this.ctx.lineCap = 'round';

      //if (Math.random() < 0.01) {
      if (this.rapid) {
        this.ctx.lineWidth = this.width * 1.5;
        this.ctx.shadowBlur = this.width * 6;
        this.ctx.shadowColor = '#FFE474';
      }

      this.ctx.stroke();

      this.ctx.restore();
    }
  }]);

  return Bit;
}();

var init = function init() {
  bits = [];
  var qty = window.innerWidth > 768 ? 64 : 32;
  var j = 1;
  for (var i = 0; i < qty; i++) {
    bits.push(new Bit(ctx, Math.floor(window.innerWidth * Math.random()), j, 1 * Math.ceil(Math.random() * 3), 1 * Math.ceil(Math.random() * 6), 1 * Math.ceil(Math.random() * 6)));

    j = j < lines - 1 ? ++j : 1;
  }
};

var delta = 0;
var lastTime = 50;
var render = function render(timestamp) {
  ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

  // When the window loses focus we get a large discrepancy between time measurements, so fix that.
  if (timestamp - lastTime >= 1000) {
    lastTime = timestamp - 60 / 1000;
  }
  // delta can be zero on first frame, so return 1.0 if 0
  delta = (timestamp - lastTime) / 1000 || 1.0;
  lastTime = timestamp;

  drawMeasures();

  for (var i = 0; i < bits.length; i++) {
    bits[i].update(delta);
    bits[i].draw();
  }

  requestAnimationFrame(render);
};

init();
render();

window.addEventListener('resize', function () {
  init();
  console.log('re-init on resize');
});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build/bundle.js